import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { TableChorinitia } from '../../genericComponents/TableChorinitia/TableChorinitia';
import * as ReqType from '../../../types/ServerRequests';
import { MediaService } from '../../../services/MediaService';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';

/**
 * interface State (le parametre de la classe)
 */
interface State {
    nouveauMedia: File | null;
    description: string;
    nom: string;
    probleme: boolean;
    messageprobleme: string;
}

/**
 * interface Props (l'état externe à la classe MediaEvent)
 */
export interface Props {
    media: ReqType.Media[]; // Array<string>
    changeMedias: (newMedias: ReqType.Media[]) => void;
    displayControls?: boolean;
    eventId: number;
}

/**
 * la classe qui permet la gestion des medias (photo et video)
 */
export class MediaEvent extends React.Component {
    props: Props;
    state: State;

    /**
     * le contructeur de la classe MediaEvent
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            nouveauMedia: null,
            description: '',
            nom: '',
            probleme: false,
            messageprobleme: '',
        };
    }

    /**
     * ajout d'un fichier
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    handleSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {

        alert(JSON.stringify(event.target.files));
        if (event.target.files !== null) {
            this.setState({ nouveauMedia: event.target.files[0] });
        }
    }

    /**
     * ajour d'une description
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    handledescription = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ description: event.target.value });
    }

    /**
     * le rendu de la classe MediaEvent
     * @returns {JSX.Element}
     */
    render() {
        var footer: JSX.Element | undefined = undefined;
        if (this.props.displayControls !== false) {
            footer = (
                <div className="card-footer">
                    <h3 style={{ fontSize: '20px', marginBottom: '20px' }}>Ajouter un média</h3>
                    <div className="row" style={{ float: 'right', marginRight: '1cm' }}>
                        <input
                            type="text"
                            placeholder="Description du média"
                            onChange={this.handledescription}
                            style={this.state.probleme === false ? { marginRight: '20px' } :
                                { borderColor: 'red', marginRight: '20px' }}
                        />
                        <input
                            type="text"
                            placeholder="Nom"
                            style={{ marginRight: '20px' }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ nom: e.target.value });
                            }}
                        />
                        <input
                            type="file"
                            id="file"
                            onChange={this.handleSelectFile}
                            style={this.state.probleme === false ? { marginRight: '20px', paddingTop: '5px' } :
                                { borderColor: 'red', marginRight: '20px', paddingTop: '5px' }}
                        />
                        <LoaderButton
                            className="btn"
                            confirmation={true}
                            modalTitle="Ajout d'un média"
                            modalBody={'Etes-vous sur de vouloir ajouter ce média'}
                            onClick={
                                () => {
                                    if (this.state.description === '' ||
                                        this.state.nouveauMedia === null) {
                                        alert('Rejected');
                                        return Promise.reject('');
                                    } else {
                                        return MediaService.getInstance()
                                            .AjouterMedia(
                                                this.state.nouveauMedia,
                                                this.state.description,
                                                this.state.nom,
                                                this.props.eventId)
                                            .then(
                                                (elem: ReqType.Media) => {
                                                    alert('Accepted');
                                                    this.props.media.push(elem);
                                                    this.props.changeMedias(this.props.media);
                                                }
                                            );
                                    }
                                }
                            }
                        >
                            Valider
                        </LoaderButton>
                    </div>
                </div >
            );
        }

        return (
            <div className="card card-default margin_Bottom: '20px">
                <div className="card-header col-12">
                    <h4 className="text-white">
                        <strong>Medias</strong>
                    </h4>
                </div>
                <div className="card-body col-8" style={{ marginLeft: '15%', overflow: 'auto', maxHeight: '700px' }}>
                    <TableChorinitia
                        header={
                            <thead>
                                <tr>
                                    <th style={{ width: '4cm' }} scope="col" >Nom</th>
                                    <th style={{ width: '3cm' }} scope="col">Etat</th>
                                    <th scope="col">Lien (Photo ou Video)</th>
                                </tr>
                            </thead>
                        }
                    >
                        <tbody>
                            {
                                this.props.media.map(this.getLine)
                            }
                        </tbody>
                    </TableChorinitia>
                </div>
                {footer}
            </div>
        );
    }

    /**
     * retourne l'etat du media (visible ou non)
     * @param {Media} media
     * @returns {JSX.element}
     */
    private getEtat(media: ReqType.Media) {
        if (media.afficher === 1) {
            return (<td className="table-success">Visible</td>);
        } else {
            return (<td className="table-danger">Non Visible</td>);
        }
    }

    /**
     *
     * @param {Media} element
     * @param {number} index
     * @returns {JSX.Element}
     */
    private getLine = (element: ReqType.Media, index: number) => {
        return (
            <tr key={element.id}>
                <td>{element.description}</td>
                {this.getEtat(element)}
                <td>
                    <a
                        href={
                            MediaService.getInstance().getBaseURL() +
                            element.lien
                        }
                        target="_blank"
                    >
                        {
                            element.type_media_id.toString() ===
                                ReqType.Type_Media.PHOTO.toString() ? (
                                    <img
                                        className="col-12"
                                        src={
                                            MediaService.getInstance().getBaseURL() +
                                            element.lien
                                        }
                                    />
                                ) : (
                                    <video controls={true} className="col-12">
                                        <source
                                            src={
                                                MediaService.getInstance().getBaseURL() +
                                                element.lien
                                            }
                                            type="video/mp4"
                                        />
                                    </video>
                                )
                        }
                    </a>
                </td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/internalComponents/MediaEvent.tsx